/* eslint-disable no-case-declarations */
import { api as $axios } from '@/helpers/interceptors'
import * as path from '@/constants/path'
import snakeCaseKeys from 'snakecase-keys'
const {
  GET_COUPON_LIST,
  CREATE_UPDATE_COUPON,
  COUPON_UPLOAD_EXCEL,
  COUPON_DELETE,
  GET_COUPON_SHOW,
  EXPORT_COUPON,
} = path
import { meta } from '@/config/pagination'

const state = () => ({
  couponList: [],
  coupons: [],
  isError: false,
  isLoading: false,
  loadingUploadFile: false,
  meta: meta,
  loadingDownloadFile: false,
})

// getters
const getters = {}

// actions
const actions = {
  async getCoupon({ commit }, params) {
    try {
      commit('SET_LOADING', true)
      const res = await $axios(GET_COUPON_LIST, 'get', { params })
      commit('SET_STATE', {
        key: `couponList`,
        value: res.data?.data,
      })
      commit('SET_STATE', {
        key: 'meta',
        value: res?.data?.meta,
      })

      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_STATE', {
        key: 'meta',
        value: meta,
      })
      commit('SET_LOADING', false)
      return new Error(e)
    }
  },

  async createCoupon({ commit }, payload) {
    try {
      commit('SET_LOADING', true)
      payload.discountAmount = parseInt(payload?.discountAmount || 0)
      await $axios(
        CREATE_UPDATE_COUPON,
        'post',
        snakeCaseKeys(payload),
      )
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
      return new Error(e)
    }
  },
  async updateCoupon({ commit }, payload) {
    try {
      const id = payload.id
      delete payload.id
      if (payload.discountAmount)
        payload.discountAmount = parseInt(payload.discountAmount)
      commit('SET_LOADING', true)
      await $axios(
        `${CREATE_UPDATE_COUPON}/${id}`,
        'put',
        snakeCaseKeys(payload),
      )
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
      return new Error(e)
    }
  },
  async delete({ commit }, id) {
    try {
      commit('SET_LOADING', true)
      await $axios(`${COUPON_DELETE}/${id}`, 'delete')
      commit('SET_LOADING', false)
    } catch (e) {
      commit('SET_LOADING', false)
      return new Error(e)
    }
  },

  setCouponList({ commit }, data) {
    commit('SET_STATE', {
      key: 'couponList',
      value: data,
    })
  },

  setCoupons({ commit }, data) {
    commit('SET_STATE', {
      key: 'coupons',
      value: data,
    })
  },
  async uploadExcel({ commit }, data) {
    try {
      commit('SET_STATE', {
        key: 'loadingUploadFile',
        value: true,
      })
      await $axios(COUPON_UPLOAD_EXCEL, 'post', data)
      commit('SET_STATE', {
        key: 'loadingUploadFile',
        value: false,
      })
    } catch (error) {
      commit('SET_STATE', {
        key: 'loadingUploadFile',
        value: false,
      })
    }
  },
  async getCouponById({ commit }, id) {
    try {
      commit('SET_LOADING', true)
      const res = await $axios(`${GET_COUPON_SHOW}/${id}`, 'get')
      commit('SET_LOADING', false)
      return res?.data?.data
    } catch (e) {
      commit('SET_LOADING', false)
      return new Error(e)
    }
  },
  async downloadExcel({ commit }, params) {
    try {
      commit('SET_STATE', { key: 'loadingDownloadFile', value: true })
      await $axios(
        `${EXPORT_COUPON}`,
        'getblob',
        snakeCaseKeys({ params }),
      ).then((response) => {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(response.data)
        link.download = `Export-Coupon-${params.campaignId}.xlsx`
        link.click()
        URL.revokeObjectURL(link.href)
      })
      commit('SET_STATE', {
        key: 'loadingDownloadFile',
        value: false,
      })
    } catch (e) {
      commit('SET_STATE', {
        key: 'loadingDownloadFile',
        value: false,
      })
      return new Error(e)
    }
  },
}

// mutations
const mutations = {
  SET_STATE(state, ops) {
    state[ops.key] = ops.value
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
